var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgClassHunter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.055 10.446 16 10.423 9.052 20.874 16 20.85 8.588 32H1.543l7.036-10.428H1.543L8.575 11.15H1.543L9.05.024 16 0zm13.89 0L16 0l6.95.024 7.507 11.126h-7.032l7.032 10.422h-7.036L30.457 32h-7.045L16 20.85l6.948.024L16 10.423z"
})));
const Memo = /*#__PURE__*/memo(SvgClassHunter);
export default Memo;